const MATCH_STYLES = {
  "MATCHED": { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  "ELIGIBLE": { bg: "#f0fdf4", text: "#15803d", border: "#bbf7d0" },
  "INVITED": { bg: "#faf5ff", text: "#7e22ce", border: "#e9d5ff" },
  "PREQUALIFIED": { bg: "#ecfeff", text: "#0e7490", border: "#a5f3fc" },
  "PREAPPROVED": { bg: "#f0fdfa", text: "#0f766e", border: "#99f6e4" },
  "APPROVED": { bg: "#15803d", text: "#ffffff", border: "#166534" },
};

export function MatchChip({ status, className = "" }) {
  const s = MATCH_STYLES[status] || MATCH_STYLES["ELIGIBLE"];
  return (
    <span
      data-testid={`match-chip-${String(status).toLowerCase()}`}
      className={`inline-flex items-center rounded-md border px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest ${className}`}
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      {status}
    </span>
  );
}
